<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    backgroundColor: string;
    color?: string;
    text?: string;
    /** Square icon-style tag, or a wider label pill for short text like course codes. */
    layout?: 'square' | 'label';
    /** Stretch vertically to fill the parent row (e.g. multi-line list items). */
    fillHeight?: boolean;
  }>(),
  {
    layout: 'square',
    fillHeight: false,
  },
);
</script>

<template>
  <div
    class="overflow-hidden rounded-lg bg-red-400 font-bold text-white transition-all duration-200 ease-out"
    :class="[
      props.text
        ? props.layout === 'label'
          ? 'inline-flex h-7 shrink-0 items-center px-2 text-xs font-semibold'
          : 'flex h-8 w-8 items-center justify-center text-[11px]'
        : props.fillHeight
          ? 'w-2 shrink-0 self-stretch rounded-md'
          : 'mx-1 h-4 w-2',
    ]"
    :style="{ backgroundColor: props.backgroundColor, color: props.color }"
  >
    {{ props.text }}
  </div>
</template>
